import timeZoneCityToCountry from '../../assets/tz-cities-to-countries.json'

function getTimeZone() {
	var userRegion = ''
	var userCity = ''
	var userCountry = ''
	var userTimeZone

	if (Intl) {
		userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
		var tzArr = userTimeZone.split('/')
		userRegion = tzArr[0]
		userCity = tzArr[tzArr.length - 1]
		//@ts-ignore
		userCountry = timeZoneCityToCountry[userCity]
	}

	return { userRegion, userCity, userCountry, userTimeZone }
}



function formatDate(date: Date) {
	var d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2)
		month = '0' + month;
	if (day.length < 2)
		day = '0' + day;

	return [day, month, year].join('/');
}

export { getTimeZone, formatDate }
